import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DailyScoreRecord, TopScoresInfo } from "@model";
import { AppHttpService } from "@core";

@Injectable({ providedIn: "root" })
export class ScoreHttpService {
  constructor(private _appHttpService: AppHttpService) {}

  getLastSavedDailyScore(): Observable<DailyScoreRecord> {
    const url = "/api/get-last-saved-score";
    return this._appHttpService.makeGETRequest<DailyScoreRecord>(url);
  }

  getDailyScoreForDateRange(rangeMin: number, rangeMax: number): Observable<DailyScoreRecord[]> {
    const url = "/api/get-scores-for-date-range";
    const params = { rangeMin, rangeMax };
    return this._appHttpService.makeGETRequest<DailyScoreRecord[]>(url, params);
  }

  setDailyScoreGoal(dailyScoreGoal: number): Observable<DailyScoreRecord> {
    const url = "/api/set-scores-goal";
    const data = { dailyScoreGoal };
    return this._appHttpService.makePOSTRequest<DailyScoreRecord>(url, data);
  }

  loadTopScores(): Observable<TopScoresInfo> {
    const url = "/api/get-top-scores";
    return this._appHttpService.makeGETRequest<TopScoresInfo>(url);
  }
}
